import React from 'react';

export const FacebookWhiteCircleSvg = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-931, -20)" fill="#FFFFFF" fillRule="nonzero">
        <path d="M951,20 C962.045695,20 971,28.954305 971,40 C971,51.045695 962.045695,60 951,60 C939.954305,60 931,51.045695 931,40 C931,28.954305 939.954305,20 951,20 Z M953.979209,27.5 C950.641502,27.5 948.460101,29.6723401 948.460101,33.6050005 L948.460101,37.0619781 L944.75,37.0619781 L944.75,41.597903 L948.460101,41.597903 L948.460101,52.5 L953.026277,52.5 L953.026277,41.597903 L956.430901,41.597903 L957.078832,37.0619781 L953.026277,37.0619781 L953.026277,34.1185231 C953.026277,32.8777338 953.592383,31.6681368 955.407474,31.6681368 L957.25,31.6681368 L957.25,27.806554 C957.25,27.806554 955.577807,27.5 953.979209,27.5 Z" />
      </g>
    </g>
  </svg>
);
